import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { TransmitterSelector } from '../components/TransmitterSelector';
import { saveSchedule } from '../actions/SaveSchedule';
import { createSchedule } from '../actions/CreateSchedule';
import { deleteSchedule } from '../actions/DeleteSchedule';
import { FormGroup } from '../components/FormGroup';
import { FormRow } from '../components/FormRow';
import { hideDialog } from '../reducers/app';
import { RadioButtons } from '../components/RadioButtons';
import { isEditScheduleKind, setEditScheduleDialogActive, setEditScheduleDialogCron, setEditScheduleDialogDimLevel, setEditScheduleDialogKind, setEditScheduleDialogOperation, setEditScheduleDialogSunAjust, setEditScheduleDialogSunScheduleRandom, setEditScheduleDialogSunType, setEditScheduleDialogSunWeekdays, setEditScheduleDialogTime, setEditScheduleDialogTransmitter, setEditScheduleDialogWeekdays } from '../reducers/edit_schedule_dialog';
import { format_time } from '../util/formatTime';
import { isScheduleRandom, isSunType } from '../types/Sun';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }, "delete"));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }, "cancel"));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }, "save"));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa schema" }, "create"));
const TimeEditor = (props) => {
    let editor;
    if (props.kind == 'cron') {
        editor = (_jsx(CronInput, {}));
    }
    else if (props.kind == 'sun') {
        editor = (_jsx(SunInput, {}));
    }
    else if (props.kind == 'time') {
        editor = (_jsx(TimeInput, {}));
    }
    else {
        editor = _jsx("div", {});
    }
    return (_jsxs(FormRow, { children: [_jsx(RadioButtons, { buttons: [{ kind: 'time', title: 'Tid' },
                    { kind: 'sun', title: 'Sol' },
                    { kind: 'cron', title: 'Cron' }], name: 'kind', kind: props.kind, updateKind: v => props.onChangeKind(v) }), editor] }));
};
const EditWeekdays = (props) => {
    return (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 3fr' }, children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "monday", checked: props.w.monday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { monday: event.target.checked })) }), "\u00A0M\u00E5n"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "tuesday", checked: props.w.tuesday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { tuesday: event.target.checked })) }), "\u00A0Tis"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "wednesday", checked: props.w.wednesday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { wednesday: event.target.checked })) }), "\u00A0Ons"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "thursday", checked: props.w.thursday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { thursday: event.target.checked })) }), "\u00A0Tor"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "friday", checked: props.w.friday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { friday: event.target.checked })) }), "\u00A0Fre"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "saturday", checked: props.w.saturday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { saturday: event.target.checked })) }), "\u00A0L\u00F6r"] }), _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "sunday", checked: props.w.sunday, onChange: event => props.update(Object.assign(Object.assign({}, props.w), { sunday: event.target.checked })) }), "\u00A0S\u00F6n"] })] }));
};
const TimeInput = () => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_schedule_dialog);
    function updateTime(v) {
        const time_parts = v.match(/(\d+):(\d+)/);
        if (time_parts) {
            const h = Number(time_parts[1]);
            const m = Number(time_parts[2]);
            dispatch(setEditScheduleDialogTime({ h, m }));
        }
    }
    function updateWeekdays(w) {
        dispatch(setEditScheduleDialogWeekdays(w));
    }
    const timeStr = format_time(dialog.time.h, dialog.time.m);
    return (_jsxs(FormRow, { children: [_jsx("input", { type: "time", name: "time.value", value: timeStr, onChange: event => updateTime(event.target.value) }), _jsx(EditWeekdays, { w: dialog.time.w, update: updateWeekdays })] }));
};
const SunInput = () => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_schedule_dialog);
    function updateKind(k) {
        if (isSunType(k)) {
            dispatch(setEditScheduleDialogSunType(k));
        }
    }
    function updateAdjust(num) {
        dispatch(setEditScheduleDialogSunAjust(num));
    }
    function updateWeekdays(w) {
        dispatch(setEditScheduleDialogSunWeekdays(w));
    }
    function updateRandom(r) {
        if (isScheduleRandom(r)) {
            dispatch(setEditScheduleDialogSunScheduleRandom(r));
        }
    }
    return (_jsxs(FormRow, { children: [_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 3fr', gridGap: '10px' }, children: [_jsxs("select", { name: "sun.kind", value: dialog.sun.k, onChange: event => updateKind(event.target.value), children: [_jsx("option", { value: "t", children: "Gryning" }), _jsx("option", { value: "u", children: "Dagsljus" }), _jsx("option", { value: "e", children: "Skymning" }), _jsx("option", { value: "n", children: "M\u00F6rker" })] }), _jsxs("select", { name: "sun.ajust", value: dialog.sun.a, onChange: event => updateAdjust(Number(event.target.value)), children: [_jsx("option", { value: "-3", children: "Ljusare -3" }), _jsx("option", { value: "-2", children: "Ljusare -2" }), _jsx("option", { value: "-1", children: "Ljusare -1" }), _jsx("option", { value: "0", children: "Neutral" }), _jsx("option", { value: "1", children: "M\u00F6rkare +1" }), _jsx("option", { value: "2", children: "M\u00F6rkare +2" }), _jsx("option", { value: "3", children: "M\u00F6rkare +3" })] })] }), _jsx("div", { style: { marginTop: '10px' }, children: _jsx(EditWeekdays, { w: dialog.sun.w, update: updateWeekdays }) }), _jsx("div", { style: { display: 'grid', gridTemplateColumns: '1fr 2fr', marginTop: '10px' }, children: _jsxs("select", { name: "sun.random", value: dialog.sun.r, onChange: event => updateRandom(event.target.value), children: [_jsx("option", { value: "r0", children: "Ingen slump" }), _jsx("option", { value: "r5", children: "Plus/minus 5 minuter" }), _jsx("option", { value: "r15", children: "Plus/minus 15 minuter" })] }) })] }));
};
const CronInput = () => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_schedule_dialog);
    function updateCron(str) {
        dispatch(setEditScheduleDialogCron(str));
    }
    return (_jsxs(FormRow, { children: [_jsx("input", { type: "text", name: "time.cron", value: dialog.cron, onChange: e => updateCron(e.target.value) }), "\u00A0 m h dom mon dow"] }));
};
const NexaOnOff = (props) => (_jsx("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 8fr', marginTop: '10px' }, children: _jsx(RadioButtons, { buttons: [{ kind: 'on', title: 'På' }, { kind: 'off', title: 'Av' }], name: 'operation', kind: props.kind, updateKind: v => props.setOperation(v) }) }));
const NexaDimmer = (props) => (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 4fr', gridGap: '10px', marginTop: '10px' }, children: [_jsx(RadioButtons, { buttons: [{ kind: 'on', title: 'På' },
                { kind: 'off', title: 'Av' },
                { kind: 'dim', title: 'Dimmer' },
            ], name: 'operation', kind: props.kind, updateKind: v => props.setOperation(v) }), _jsxs("select", { name: "dim_level", value: props.dim_level, onChange: event => props.setDimLevel(Number(event.target.value)), children: [_jsx("option", { value: "1", children: "1" }), _jsx("option", { value: "2", children: "2" }), _jsx("option", { value: "3", children: "3" }), _jsx("option", { value: "4", children: "4" }), _jsx("option", { value: "5", children: "5" }), _jsx("option", { value: "6", children: "6" }), _jsx("option", { value: "7", children: "7" }), _jsx("option", { value: "8", children: "8" }), _jsx("option", { value: "9", children: "9" }), _jsx("option", { value: "10", children: "10" }), _jsx("option", { value: "11", children: "11" }), _jsx("option", { value: "12", children: "12" }), _jsx("option", { value: "13", children: "13" }), _jsx("option", { value: "14", children: "14" }), _jsx("option", { value: "15", children: "15" }), _jsx("option", { value: "16", children: "16" })] })] }));
const ZigbeeOnOff = (props) => (_jsx("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr 8fr', marginTop: '10px' }, children: _jsx(RadioButtons, { buttons: [{ kind: 'zigbee on', title: 'På' },
            { kind: 'zigbee off', title: 'Av' },
        ], name: 'operation', kind: props.kind, updateKind: v => props.setOperation(v) }) }));
export const DialogScheduleEdit = (props) => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_schedule_dialog);
    const definitions = useAppSelector(state => state.definitions);
    const device_kind = get_device_kind(definitions, dialog.transmitter_id);
    let footer, transmitter, transmitter_operation;
    if (dialog.id) {
        footer = [
            (_jsx(DeleteButton, { onClick: () => { if (dialog.id !== null) {
                    dispatch(deleteSchedule(dialog.id));
                } } }, "delete")),
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(saveSchedule(dialog)) }, "save"))
        ];
    }
    else {
        footer = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createSchedule(dialog)) }, "create"))
        ];
    }
    if (props.device_id != undefined) {
        transmitter = (_jsx("input", { name: "transmitter_id", value: props.device_id, hidden: true, readOnly: true }));
    }
    else {
        transmitter =
            (_jsx(TransmitterSelector, { name: "transmitter_id", value: dialog.transmitter_id, onChange: event => dispatch(setEditScheduleDialogTransmitter(Number(event.target.value))) }));
    }
    switch (device_kind) {
        case 'nexa onoff':
            transmitter_operation = _jsx(NexaOnOff, { kind: dialog.operation, setOperation: v => dispatch(setEditScheduleDialogOperation(v)) });
            break;
        case 'nexa dimmer':
            transmitter_operation = _jsx(NexaDimmer, { kind: dialog.operation, dim_level: dialog.dim_level, setOperation: v => dispatch(setEditScheduleDialogOperation(v)), setDimLevel: v => dispatch(setEditScheduleDialogDimLevel(v)) });
            break;
        case 'zigbee onoff':
            transmitter_operation = _jsx(ZigbeeOnOff, { kind: dialog.operation, setOperation: v => dispatch(setEditScheduleDialogOperation(v)) });
            break;
        default:
            transmitter_operation = _jsx("div", { children: "No operation for this unit" });
            break;
    }
    function onChangeActive(v) {
        dispatch(setEditScheduleDialogActive(v));
    }
    function onChangeKind(v) {
        if (isEditScheduleKind(v)) {
            dispatch(setEditScheduleDialogKind(v));
        }
    }
    return (_jsxs(Dialog, { id: "schedule-edit", title: "Redigera schema", footer: footer, children: [_jsx(TimeEditor, { dialog: dialog, kind: dialog.kind, time: dialog.time, onChangeKind: onChangeKind }), _jsx(FormRow, { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", name: "active", checked: dialog.active, onChange: event => onChangeActive(event.target.checked) }), "\u00A0Aktiv"] }) }), _jsx("hr", {}), _jsx(FormRow, { children: _jsxs(FormGroup, { label: "S\u00E4ndare", children: [transmitter, transmitter_operation] }) })] }));
};
function get_device_kind(definitions, transmitter_id) {
    if (!isNaN(transmitter_id)) {
        const d = definitions.devices[transmitter_id];
        if (d) {
            if (d.protocol.name == 'nexa transmitter') {
                if (d.protocol.kind == 'onoff') {
                    return 'nexa onoff';
                }
                else if (d.protocol.kind == 'dimmer') {
                    return 'nexa dimmer';
                }
            }
            else if (d.protocol.name == 'zigbee') {
                return 'zigbee onoff';
            }
        }
        else {
            console.log('Invalid device id ' + transmitter_id);
        }
    }
    return 'no device kind';
}
